import { defaultNow } from '../../../../common/utils/dateTimeNow'
import { FormikProps, useFormikContext } from 'formik'
import { Dispatch, SetStateAction } from 'react'
import { BoxV2, ExternalLink } from '@labrav/react-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileContract } from '@fortawesome/pro-regular-svg-icons'
import { useStyles } from './EulaSection.styles'
import { MsftCombinedFormState } from '../../../../modules/microsoftCombinedForm/reducer'
import { microsoftStandardEula } from '../../../../common/utils/constants'
import { EulaSectionContent } from '../../../../common/components/EulaSection/EulaSection'
import {
  CombinedFormFAQs,
  CombinedFormFAQsItem,
} from '../CombinedFormFAQs/CombinedFormFAQs'

export const EulaSection = ({
  eulaErr,
  disabled,
  setEulaErr,
}: {
  eulaErr: string
  disabled: boolean
  setEulaErr: Dispatch<SetStateAction<string>>
}) => {
  const { classes } = useStyles()
  const updateErr = (error: string) => {
    setEulaErr(error)
  }
  const formikProps = useFormikContext() as FormikProps<MsftCombinedFormState>
  const { touched, errors } = formikProps
  return (
    <>
      <div data-testid="combined-form-resale-auth-eula">
        <BoxV2
          heading={'End-user License Agreement (EULA)'}
          headingIcon={
            <FontAwesomeIcon
              icon={faFileContract}
              style={{ width: '14px', height: '14px' }}
            />
          }
          secondaryActions={
            <CombinedFormFAQs item={CombinedFormFAQsItem.EULA} />
          }
        >
          <div className={classes.viewEulaContainer}>
            <p className={classes.viewEulaDescription}>
              ISV has provided an EULA for this reseller authorization. It will
              be presented to buyer alongside your EULA.
            </p>
            <ExternalLink href={microsoftStandardEula}>View EULA</ExternalLink>
          </div>
        </BoxV2>
      </div>
      <div data-testid="channel-offer-eula-uploader">
        <BoxV2
          heading={'Attach your EULA for buyer'}
          headingIcon={
            <FontAwesomeIcon
              icon={faFileContract}
              style={{ width: '14px', height: '14px' }}
            />
          }
          secondaryActions={
            <CombinedFormFAQs item={CombinedFormFAQsItem.RESELLER_EULA} />
          }
          isOptional
        >
          <EulaSectionContent
            defaultNow={defaultNow}
            formik={
              formikProps as unknown as FormikProps<Record<string, unknown>>
            }
            isMultiFileUpload={true}
            fileUploadDescription={
              'Upload up to 5 files one by one, use plain text .txt or PDF formats only. The maximum file size is 10 MB.'
            }
            fileUploadButtonText={'Upload files'}
            fileUploadContainerTitle={
              'Upload a up to 5 PDF files. Drag and drop it below.'
            }
            quantity={5}
            eulaOptionsHeading={'Legal term documents'}
            showEulaFileUpload={true}
            showEulaOptions={false}
            fileSize={10}
            updateErr={updateErr}
            uploadError={
              eulaErr ||
              (touched?.draftOffer?.resellerEulaFiles
                ? (errors?.draftOffer?.resellerEulaFiles as string)
                : '')
            }
            uploadFolderName="microsoft_combined_form_eula_files"
            eulaFilesKeyName={'draftOffer.resellerEulaFiles'}
            disableEulaFileUpload={disabled}
            disabled={disabled}
            disableEulaOptions={disabled}
          />
        </BoxV2>
      </div>
    </>
  )
}
